export function schema_split_zone() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			column_id: {
				type: "string",
				title: "Colonne des id",
			},
			column_page: {
				type: "string",
				title: "Colonne des noms des pages",
			},
			column_doc: {
				type: "string",
				title: "Colonne des noms des documents générés",
			},
		},
	};
}
